export default __webpack_public_path__ + "static/media/backgroundnew.3396be41.png";